import React from "react";
import { motion } from "framer-motion";
import { Phone, Settings, Rocket } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { SectionHeader } from "./Features";

const ICONS = [Phone, Settings, Rocket];

export default function HowItWorks() {
  const { t } = useLang();
  return (
    <section id="how" className="relative py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <SectionHeader eyebrow={t.how.eyebrow} title={t.how.title} />

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 relative">
          {/* Connecting line */}
          <div className="hidden md:block absolute left-[16%] right-[16%] top-12 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />

          {t.how.steps.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.55, delay: i * 0.1 }}
                className="relative rounded-3xl bg-surface/60 border border-white/[0.07] p-7 md:p-8"
                data-testid={`how-step-${i}`}
              >
                <div className="relative flex items-start justify-between mb-5">
                  <div className="w-14 h-14 rounded-2xl bg-brand-orange/15 border border-brand-orange/25 flex items-center justify-center">
                    <Icon className="text-brand-orange" size={26} strokeWidth={1.75} />
                  </div>
                  <span className="font-heading text-5xl font-bold text-white/[0.06] leading-none">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="text-xl font-semibold text-white mb-2 tracking-tight">{s.title}</h3>
                <p className="text-sm md:text-[15px] text-white/60 leading-relaxed">{s.body}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
